'use client';

import { PropsWithChildren, useMemo, useState, memo } from 'react';
import { ComponentMemo } from '@headless-workspace/typings';
import {
    LayoutActionContext,
    LayoutActionContextType,
    LayoutStateContext,
    LayoutStateContextType,
} from './LayoutContext';

export const LayoutProvider: ComponentMemo<PropsWithChildren> = memo(({ children }) => {
    const [headerOffset, setHeaderOffset] = useState(0);
    const [headerHeight, setHeaderHeight] = useState(0);
    const [fixedAddToBasketVisible, setFixedAddToBasketVisible] = useState(false);
    const [fixedAddToBasketHeight, setFixedAddToBasketHeight] = useState(0);

    const layoutStateProviderValue: LayoutStateContextType = useMemo(
        () => ({
            header: {
                headerOffset: headerOffset,
                headerHeight: headerHeight,
            },
            fixedAddToBasket: {
                fixedAddToBasketVisible,
                fixedAddToBasketHeight,
            },
        }),
        [headerOffset, fixedAddToBasketHeight, headerHeight, fixedAddToBasketVisible],
    );

    const layoutActionProviderValue: LayoutActionContextType = useMemo(
        () => ({
            header: {
                setHeaderOffset: setHeaderOffset,
                setHeaderHeight: setHeaderHeight,
            },
            fixedAddToBasket: {
                setFixedAddToBasketVisible: setFixedAddToBasketVisible,
                setFixedAddToBasketHeight: setFixedAddToBasketHeight,
            },
        }),
        [],
    );

    return (
        <LayoutStateContext.Provider value={layoutStateProviderValue}>
            <LayoutActionContext.Provider value={layoutActionProviderValue}>{children}</LayoutActionContext.Provider>
        </LayoutStateContext.Provider>
    );
});

LayoutProvider.displayName = 'LayoutProvider';
